import { useCallback } from 'react';
import { SaveLimitsArgs } from '../../components/GamingActivity/types';
import {
  CUSTOM_AMOUNT_OPTION,
  CUSTOM_SESSION_DURATION,
  LIMIT_TYPES
} from '../../constants';
import useSetLimits from '../useSetLimits';

const useOnSaveLimits = () => {
  const { updateLimits } = useSetLimits();

  const onSaveLimits = useCallback(
    async ({
      limit,
      amount,
      period,
      duration,
      durationAmount = 0
    }: SaveLimitsArgs) => {
      const maxDepPayload = {
        type: LIMIT_TYPES.MAX_DEPOSIT,
        amount: limit === CUSTOM_AMOUNT_OPTION ? amount : limit,
        period
      };

      const gameActivityPayload = {
        type: LIMIT_TYPES.GAME_ACTIVITY,
        amount:
          duration === CUSTOM_SESSION_DURATION
            ? durationAmount * 60 * 60
            : duration,
        period
      };

      await updateLimits([maxDepPayload, gameActivityPayload]);
    },
    [updateLimits]
  );
  return {
    onSaveLimits
  };
};

export default useOnSaveLimits;
